module.exports = __webpack_public_path__ + "media/images/placeholders/video-player-with-play-a28a325c07b44856ddd1a4ad551538b9.png";